<template>
  <div id="app">
    <Navbar />
    <main>
      <router-view :style="viewStyle"/>
    </main>
    <footer>

    </footer>
  </div>
</template>

<script>
import Navbar from '@/components/layout/Navbar.vue'
import { mapState } from 'vuex'

export default {
  name: 'Main',
  components: {
    Navbar
  },
  computed: {
    ...mapState([
      'navHeight'
    ]),
    viewStyle () {
      return {
        marginTop: this.navHeight + 'px'
      }
    }
  }
}
</script>

<style>

html,
body {
  user-select: none;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.app-blurb {
  width: 60%;
  margin: auto;
}

@import './assets/css/materialize.css';
@import './assets/fonts/google_font.css';
</style>
